(function () {
  const root = document.documentElement;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const designMode = Boolean(window.Shopify && window.Shopify.designMode);
  let observer = null;

  const motionAllowed = () => !reduce.matches && !root.classList.contains('leo-motion-off') && !designMode && 'IntersectionObserver' in window;

  const reveal = (element) => {
    element.classList.add('is-in');
    element.classList.remove('is-waiting');
  };

  const getObserver = () => {
    if (observer) return observer;
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }
    );
    return observer;
  };

  const scan = (scope) => {
    const elements = (scope || document).querySelectorAll('[data-leo-reveal]:not([data-leo-seen])');
    const allowed = motionAllowed();
    const viewHeight = window.innerHeight || root.clientHeight;
    elements.forEach((element) => {
      element.setAttribute('data-leo-seen', '');
      if (!allowed) {
        element.classList.add('is-in', 'is-instant');
        return;
      }
      const rect = element.getBoundingClientRect();
      if (rect.top < viewHeight * 0.88 && rect.bottom > 0) {
        element.classList.add('is-in', 'is-instant');
        return;
      }
      element.classList.add('is-waiting');
      getObserver().observe(element);
    });
  };

  const start = () => scan(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => scan(event.target));

  const onPreferenceChange = () => {
    if (motionAllowed()) return;
    document.querySelectorAll('[data-leo-reveal].is-waiting').forEach(reveal);
  };

  if (typeof reduce.addEventListener === 'function') {
    reduce.addEventListener('change', onPreferenceChange);
  }
})();
